<template>
  <div>
    <b-card>
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h4 class="mb-0">Manifests Pickup</h4>
        <b-button
          v-if="canCreate"
          variant="primary"
          :to="{ name: 'manifest-create' }"
        >
          <feather-icon icon="PlusIcon" class="mr-1" />
          Créer un manifeste
        </b-button>
      </div>

      <vue-good-table
        :columns="columns"
        :rows="manifestRows"
        :is-loading="isLoading"
        :pagination-options="paginationOptions"
        :search-options="searchOptions"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'created_by_label'">
            {{ props.row.created_by_label }}
            <br>
            <small class="text-muted">{{ props.row.created_by_role }}</small>
          </span>
          <span v-else-if="props.column.field === 'actions'">
            <b-button
              size="sm"
              variant="outline-primary"
              :to="{ name: 'manifest-detail', params: { id: props.row.id } }"
            >
              <feather-icon icon="EyeIcon" />
            </b-button>
          </span>
          <span v-else>{{ props.formattedRow[props.column.field] || '-' }}</span>
        </template>
      </vue-good-table>
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { VueGoodTable } from 'vue-good-table'

export default {
  name: 'ManifestsPickupIndex',
  components: { VueGoodTable },
  computed: {
    ...mapGetters('manifestsPickup', ['manifests', 'isLoading']),
    ...mapGetters(['userRole']),
    canCreate() {
      return ['admin', 'superadmin', 'manager'].includes(this.userRole)
    },
    manifestRows() {
      return this.manifests.map(manifest => ({
        ...manifest,
        outsourcing_company_label: manifest.outsourcing_company?.display_name || manifest.outsourcing_company?.name || '-',
        created_by_label: manifest.created_by?.username || '-',
        created_by_role: manifest.created_by?.role || '-',
        note_label: manifest.note || '-',
        created_at_label: this.formatDate(manifest.created_at),
      }))
    },
    columns() {
      return [
        { label: '#', field: 'id', type: 'number' },
        { label: 'Société sous-traitance', field: 'outsourcing_company_label' },
        { label: 'Créé par', field: 'created_by_label' },
        { label: 'Nb colis', field: 'orders_count', type: 'number' },
        { label: 'Note', field: 'note_label' },
        { label: 'Créé le', field: 'created_at_label' },
        { label: 'Actions', field: 'actions', sortable: false },
      ]
    },
    paginationOptions() {
      return {
        enabled: true,
        mode: 'pages',
        perPage: 20,
      }
    },
    searchOptions() {
      return {
        enabled: true,
        placeholder: 'Rechercher un manifeste',
      }
    },
  },
  created() {
    this.fetchManifests()
  },
  methods: {
    ...mapActions('manifestsPickup', ['fetchManifests']),
    formatDate(dateStr) {
      if (!dateStr) return '-'
      return new Date(dateStr).toLocaleString('fr-TN')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
